import { Link } from "react-router-dom";
import type { AriaAttributes, ReactNode } from "react";

export function RouterLink({
  href,
  className,
  children,
  "aria-current": ariaCurrent,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  "aria-current"?: string;
}) {
  return (
    <Link
      to={href}
      className={className}
      aria-current={ariaCurrent as AriaAttributes["aria-current"]}
    >
      {children}
    </Link>
  );
}
